import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiPlus } from "react-icons/fi";
import { api } from "../../services/api";

import { ItemPagination } from "../../components/ItemPagination";
import { AuthContext, useAuth } from "../../contexts/AuthContext";
import { PageTitle } from "../../components/PageTitle";
import { EmptyState } from "../../components/EmptyState";
import { CanAccess } from "../../components/CanAccess";

interface Equipment {
  id: string;
  name: string;
  status: string;
}

export function Equipments() {
  const { user } = useContext(AuthContext);
  const { hasPermission } = useAuth();
  const [equipments, setEquipments] = useState<Equipment[]>([]);
  const [changeStatus, setChangeStatus] = useState<number>(0);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    api
      .get("/equipments")
      .then(response => {
        setEquipments(response.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        navigate("/signin");
      });
  }, [changeStatus]);

  async function handleChangeStatus(id: string, newStatus: string) {
    api.patch(`equipments/status/${id}/${newStatus === "A" ? "I" : "A"}`);
    setTimeout(() => {
      setChangeStatus(changeStatus + 1);
    }, 1000);
  }

  return (
    <div className="container mx-auto">
      <PageTitle
        title="Equipamentos"
        backButton
        backPath="/home"
      />
      <div className="flex items-start justify-between mb-6">
        <CanAccess permission="equipments:create" allowAdmin>
          <Link
            to="/equipments/new"
            className="group bg-[#0085BD] text-white w-12 h-12 rounded-full flex items-center justify-center shadow-lg hover:bg-[#006a96] transition-all duration-200 hover:shadow-xl"
          >
            <FiPlus size={24} className="transition-transform duration-200 group-hover:rotate-90" />
          </Link>
        </CanAccess>
      </div>
      <div className="space-y-2">
        {loading && (
          <div className="flex items-center justify-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0085BD]" />
          </div>
        )}
        {!loading &&
          equipments.length > 0 &&
          equipments.map(({ id, name, status }: Equipment) => (
            <ItemPagination
              key={id}
              title={name}
              id={id}
              status={status}
              hasDelete
              canEdit={hasPermission("equipments:update")}
              canDelete={hasPermission("equipments:delete")}
              handleChangeStatus={() => handleChangeStatus(id, status)}
            />
          ))}
        {!loading && equipments.length === 0 && (
          <div className="col-span-full">
            <EmptyState type="equipments" />
          </div>
        )}
      </div>
    </div>
  );
}
